import React, { useEffect, useState, memo } from "react";
import { Button, Col, Row, Form, Table } from "react-bootstrap";
import { IoAddCircleSharp } from "react-icons/io5";
import ApiService from "../../../helper/api";
import AlertService from "../../../helper/alertService";
import UrlForm from "./UrlForm";

const Urls = ({ _urls, urlTypes, urlNames }) => {
	const [disabledButton, setDisabledButton] = useState(null);
	const [urls, setUrls] = useState([]);
	const [selectedUrl, setSelectedUrl] = useState(null);
	const [isShowUrlForm, setIsShowUrlForm] = useState(false);

	useEffect(() => {
		if (_urls && _urls.length) {
			setUrls(_urls);
		}
	}, [_urls]);

	const deleteUrl = id => {
		setDisabledButton(id);
		AlertService.alertConfirm("Are you sure ?").then(res => {
			ApiService.deleteUrl(id)
				.then(response => {
					setUrls(urls.filter(item => item.id !== id));
					AlertService.alert("success", "Url Deleted successfully");
				})
				.catch(error => AlertService.alert("error", error))
				.finally(() => {
					setDisabledButton(null);
				});
		});
	};

	return (
		<>
			{/* ===== HEADER ===== */}
			<div className="d-flex justify-content-between align-items-center mb-3">
				<h6 className="mb-0 fw-semibold">URLs</h6>

				<Button
					variant="success"
					size="sm"
					className="d-flex align-items-center gap-1"
					onClick={() => setIsShowUrlForm(true)}>
					<IoAddCircleSharp size={18} />
					Add
				</Button>
			</div>

			{/* ===== TABLE ===== */}
			{urls && urls.length > 0 ? (
				<Table responsive hover bordered className="align-middle">
					<thead className="table-light">
						<tr>
							<th>#</th>
							<th>Url Type</th>
							<th>Url Name</th>
							<th>Address</th>
							<th>Description</th>
							<th>Request Model</th>
							<th>Response Model</th>
							<th className="text-end">Actions</th>
						</tr>
					</thead>

					<tbody>
						{urls.map((item, index) => (
							<tr key={index}>
								<td className="text-muted">{index + 1}</td>

								<td>
									<span className="max-line-1" title={item.urlType}>
										{item.urlType}
									</span>
								</td>

								<td>
									<span className="max-line-1" title={item.urlName}>
										{item.urlName}
									</span>
								</td>

								<td>
									<span className="max-line-1" title={item.address}>
										{item.address}
									</span>
								</td>

								<td>
									<span className="max-line-1" title={item.description}>
										{item.description}
									</span>
								</td>

								<td>
									<span className="max-line-1" title={item.requestModel}>
										{item.requestModel}
									</span>
								</td>

								<td>
									<span className="max-line-1" title={item.responseModel}>
										{item.responseModel}
									</span>
								</td>

								<td className="text-end">
									<div className="d-flex justify-content-end gap-2">
										<Button
											size="sm"
											variant="outline-primary"
											onClick={() => setSelectedUrl(item)}>
											Edit
										</Button>

										<Button
											size="sm"
											variant="outline-danger"
											disabled={item.id === disabledButton}
											onClick={() => deleteUrl(item.id)}>
											Delete
										</Button>
									</div>
								</td>
							</tr>
						))}
					</tbody>
				</Table>
			) : (
				<p className="text-muted mb-0">No URLs</p>
			)}

			{/* <Row>
				<Col sm={12}>
					<div className="d-flex justify-content-between mb-3">
						<Form.Label>URL-s</Form.Label>
						<Button
							variant="outline-success"
							className="d-flex py-2 px-3"
							onClick={() => {
								setIsShowUrlForm(true);
							}}>
							<IoAddCircleSharp />
						</Button>
					</div>
					{urls && !!urls.length &&
						<Table responsive bordered striped >
							<thead >
								<tr>
									<th scope="col text-nowrap" style={{ backgroundColor: "rgb(111 255 159)" }}>#</th>
									<th scope="col text-nowrap" style={{ backgroundColor: "rgb(111 255 159)" }}>UrlType</th>
									<th scope="col text-nowrap" style={{ backgroundColor: "rgb(111 255 159)" }} >UrlName</th>
									<th scope="col text-nowrap" style={{ backgroundColor: "rgb(111 255 159)" }} >Address</th>
									<th scope="col text-nowrap" style={{ backgroundColor: "rgb(111 255 159)" }} >Description</th>
									<th scope="col text-nowrap" style={{ backgroundColor: "rgb(111 255 159)" }} >RequestModel</th>
									<th scope="col text-nowrap" style={{ backgroundColor: "rgb(111 255 159)" }} >ResponseModel</th>
									<th scope="col text-nowrap" style={{ backgroundColor: "rgb(111 255 159)" }} >Actions</th>

								</tr>
							</thead>
							<tbody>
								{
									urls.map((item, index) => {
										return <tr key={index} >

											<th scope="row" className="gray-text">{index + 1}</th>
											<td style={{ maxWidth: "100px" }}><span className="max-line-1 " title={item.urlType}>{item.urlType}</span></td>
											<td style={{ maxWidth: "100px" }}><span className="max-line-1 " title={item.urlName}>{item.urlName}</span></td>
											<td style={{ maxWidth: "100px" }}><span className="max-line-1 " title={item.address}>{item.address}</span></td>
											<td style={{ maxWidth: "100px" }}><span className="max-line-1 " title={item.description}>{item.description}</span></td>
											<td style={{ maxWidth: "100px" }}><span className="max-line-1 " title={item.requestModel}>{item.requestModel}</span></td>
											<td style={{ maxWidth: "100px" }}><span className="max-line-1 " title={item.responseModel}>{item.responseModel}</span></td>
											<td style={{ maxWidth: "100px" }}>
												<div className="d-flex gap-2">
													<Button
														size="sm"
														variant="primary"
														onClick={() => setSelectedUrl(item)}
													>
														Edit
													</Button>
													<Button
														size="sm"
														variant="danger"
														disabled={item.id === disabledButton}
														onClick={() => {
															deleteUrl(item.id);
														}}
													>
														Delete
													</Button>

												</div>
											</td>
										</tr>
									})
								}

							</tbody>
						</Table>
					}
				</Col>
			</Row> */}

			{urlTypes && urlTypes.length && urlNames && urlNames.length ? (
				<UrlForm
					_selectedUrl={selectedUrl}
					isShowUrlForm={isShowUrlForm}
					setIsShowUrlForm={setIsShowUrlForm}
					urlTypes={urlTypes}
					urlNames={urlNames}
				/>
			) : null}
		</>
	);
};

export default memo(Urls);
